<template>
    <div>
        <div class="flex flex-col sm:flex-row flex-wrap">
            <template v-for="(step, id) in steps">
                <div :key="id" class="sm:w-1/2" v-if="showStep(step)">
                    <h2 class="text-2xl">
                        <router-link 
                            tabindex="0"
                            v-if="$store.state.configs.routing"
                            :to="`/step/${id}`"
                        >
                            {{step.title ? step.title : `Step ${id}`}}
                        </router-link>
                        <a v-else
                            href="#"
                            @click.prevent="
                                $store.commit('updateField', {
                                    field : 'step',
                                    value : id
                                });
                            "
                        >
                             {{step.title ? step.title : `Step ${id}`}}
                        </a>
                    </h2>
                    <ul class="list-none">
                        <li v-for="(field, key) in showFields(step)" class="mb-4" :key="key">
                            <p class="font-bold">{{field.label}}</p>
                            <div v-for="(option, opt) in (typeof $store.state.data[field.id] != 'string' ? $store.state.data[field.id] : [$store.state.data[field.id]])" :key="opt">
                                <template v-if="option != null && typeof option == 'object' && option.date != undefined">
                                    <p>
                                        {{getDayOfTheWeek(option.date)}} {{getDateString(option.date)}}
                                    </p>
                                    <p v-text="option.time == null ? 'No Preference' : option.time"></p>
                                </template>
                                <p v-else-if="field.type == 'date'" v-text="getDate(option)"></p>
                                <p v-else-if="['select','radio','checkbox'].includes(field.type)" v-html="getLabel(field,option)"></p>
                                <p v-else>
                                    {{option}}
                                </p>
                            </div>
                        </li>
                    </ul>
                    
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        steps() {
            return this.$store.state.steps;
        },
        form() {
            return window.booking_form;
        },
        // reason() {
        //     if (this.$store.state.data.reason == undefined)
        //         return null;

        //     return this.$store.state.data.reason.post_title;
        // },
        // preferred_provider() {
        //     if (typeof this.$store.state.data.provider == "undefined")
        //         return "None";

        //     return window.departments[
        //         this.$store.state.data.service
        //     ].staff.find((e) => e.ID == this.$store.state.data.provider)
        //         .post_title;
        // },
    },
    methods: {
        showStep(step) {
            return this.showFields(step).length > 0;
        },
        showFields(step) {
            let fields = step.fields.filter(field => 
                field.visibility == "visible" &&
                field.type != "hidden" &&
                this.$store.state.data[field.id] != undefined &&
                this.$store.state.data[field.id] != ""
            );
            return fields;
        },
        getDateString(day) {
            let d = new Date(day.replace(/-/g, "/").replace(/T.+/, ""));

            return (
                `${d.toLocaleString("default", { month: "long" })} ${d.getDate()}, ${d.getFullYear()}`
            );
        },
        getDate(day) {
            day = new Date(
                day.replace(/-/g, "/").replace(/T.+/, "")
            );

            return `${(day.getMonth() + 1)}/${day.getDate()}/${day.getFullYear()}`;
        },
        getDayOfTheWeek(day) {
            let d = new Date(day.replace(/-/g, "/").replace(/T.+/, ""));

            return this.$store.state.dayOfWeek[d.getDay()];
        },
        getLabel(field,option) {
            let label = field.choices.find(choice => choice.value == option);

            return label ? label.text : option;
        }
    },
};
</script>